import { getNavigate } from '@/services/NavigationService';

export const historyPush = (route: string, data: Record<string, any> = {}) => {
	const navigate = getNavigate();
	if (navigate) {
		navigate(route, { state: data });
	} else {
		console.warn('Navigate function not available yet');
	}
};

export const historyReplace = (route: string, data: Record<string, any> = {}) => {
	const navigate = getNavigate();
	if (navigate) {
		navigate(route, { state: data, replace: true });
	} else {
		console.warn('Navigate function not available yet');
	}
};
